import { loginRequest } from "../authConfig";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { ReactElement, useEffect } from "react";

export function AuthLayout({ children }: { children: ReactElement }) {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    if (inProgress !== "none") {
      return;
    }
    if (!isAuthenticated) {
      instance.loginRedirect(loginRequest).catch((e) => {
        console.error(e);
      });
    }
  }, [isAuthenticated, instance, inProgress]);

  return (
    <>
      {inProgress !== "none" && <></>}
      {inProgress === "none" && isAuthenticated && children}
    </>
  );
}
